import { useFeatureBadgeStore } from "@lib/featureBadgeStore";
import { featureMap } from "@lib/help";

export function useIsFeatureNew(id: string): boolean {
  const dismissed = useFeatureBadgeStore((state) => state.dismissed);

  const feature = featureMap.get(id);
  if (!feature) return false;

  const dismissedVersion = dismissed[id];
  return dismissedVersion !== feature.addedInVersion;
}
